import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';

const SummaryCard = styledComponent('div', {
  background: '#f6f8f5',
  border: '1px solid #ddd',
  borderRadius: '4px',
  padding: '20px',
  marginBottom: '20px',
});

const SummaryTitle = styledComponent('div', {
  fontWeight: 700,
  fontSize: '16px',
  marginBottom: '15px',
  color: '#2c2d31',
});

const PalletSummaryCard = ({
  linehaul,
  region,
  middleMile,
  totalPallets,
  marketBreakdown,
}) => {
  return (
    <SummaryCard className="no-print">
      <SummaryTitle>PALLET SUMMARY - {linehaul} Linehaul</SummaryTitle>
      <div className="row">
        <div className="col-sm-4">
          <strong>Region:</strong> {region}
          <br />
          <strong>Linehaul:</strong> {linehaul}
          <br />
          {middleMile && (
            <>
              <strong>Middle Mile:</strong> {middleMile}
              <br />
            </>
          )}
          <strong>Total Pallets:</strong> {totalPallets}
        </div>
        <div className="col-sm-8">
          {Object.entries(marketBreakdown).map(([market, count]) => (
            <span key={market} style={{ marginRight: '20px' }}>
              {market} &rarr; {count} {count === 1 ? 'pallet' : 'pallets'}
            </span>
          ))}
        </div>
      </div>
    </SummaryCard>
  );
};

PalletSummaryCard.propTypes = {
  linehaul: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  middleMile: PropTypes.string,
  totalPallets: PropTypes.number.isRequired,
  marketBreakdown: PropTypes.objectOf(PropTypes.number).isRequired,
};

PalletSummaryCard.defaultProps = {
  middleMile: null,
};

export default PalletSummaryCard;
